import { Table } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function FilteredTable({filteredData,isLoading}) {
  const [sortedInfo, setSortedInfo] = useState({});

  const handleChange = (sorter) => {
    setSortedInfo(sorter);
  };

  const navigate = useNavigate();

  const columns = [
    {
      title: "Property-Unit",
      dataIndex: "propertyUnit",
      key: "propertyUnit",
      render: (_, record) => <span>{record.property?.propertyNameAddress?.propertyName}</span>,
      sorter: (a, b) => a.propertyUnit.length - b.propertyUnit.length,
      sortOrder:
        sortedInfo.columnKey === "propertyUnit" ? sortedInfo.order : null,
    },
    {
      title: "Tenants",
      dataIndex: "tenants",
      key: "tenants",
      render: (_, record) => <span>{record.tenant?.profileInfo?.firstName} {record.tenant?.profileInfo?.lastName}</span>,
    },
    {
      title: "Expiration",
      dataIndex: "expiration",
      key: "expiration",
      render: (_, record) => <span>{record.leaseDates?.leaseEndDate ? record.leaseDates?.leaseEndDate : "--"}</span>,
      sorter: (a, b) => a.expiration.length - b.expiration.length,
      sortOrder:
        sortedInfo.columnKey === "expiration" ? sortedInfo.order : null,
    },
    {
      title: "Current Rent",
      dataIndex: "currentRent",
      key: "currentRent",
      render: (_, record) => <span>$ {record.rentalInformation?.legalRent ? record.rentalInformation?.legalRent : "--"}</span>,
    },
    {
      title: "New Rent",
      dataIndex: "newRent",
      key: "newRent",
      render: (_, record) => <span>$ {record.rentalInformation?.newRent ? record.rentalInformation?.newRent : "--"}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status.length - b.status.length,
      sortOrder: sortedInfo.columnKey === "status" ? sortedInfo.order : null,
      render: (_, record) => <>
      <p>{record.status}</p>
      {/* <span className="onclick-text" onClick={()=>navigate(`/leasing/renewals/${record.id}`)}>Prepare Renewal Offer</span> */}
      <span className="onclick-text" onClick={()=>navigate(`#`)}>Prepare Renewal Offer</span>
      </>,
    },
  ];

  return (
    <div className="table-container">
      <Table
        columns={columns}
        dataSource={filteredData}
        onChange={handleChange}
        loading={isLoading}
        rowKey={(_, record) => record.id}
      />
    </div>
  );
}

export default FilteredTable;
